import { ErnotsConfig } from "../../../../ErnotsConfig";
import { Button } from "../../../RequestRespectingInputs";

export function QueryTranslationButtonSaved(props: Props)
{
    return (
        <Button
            disabled={props.sourceTextEmpty}
            onClick={function(e)
            {
                let buttonURL = ErnotsConfig.APIURLPrefix + `book/${props.bookId}/sentences/`;
                buttonURL = props.googlify(buttonURL);
                window.open(buttonURL, '_blank');
            }}>{props.buttonText}</Button>
    );
}

interface Props
{
    bookId: string;
    buttonText: string;
    sourceTextEmpty: boolean;
    googlify: (url: string) => string;
}